import { useReducer } from "react";
import { format as dateFormat, add as dateAdd } from "date-fns";

// Constants
import { orderSearchCategories, orderHistoryVars } from "../../../../constants";

const intialGlobalFilterState = {
  searchBy: orderSearchCategories.dateRange.value,
  fromDate: dateFormat(
    dateAdd(new Date(), { days: orderHistoryVars.defaultFromOffset }),
    "yyyy-MM-dd",
  ),
  toDate: dateFormat(
    dateAdd(new Date(), { days: orderHistoryVars.defaultToOffset }),
    "yyyy-MM-dd",
  ),
  barcodes: [],
  invoices: [],
};

const ACTIONS = {
  DATE_RANGE: "DATE_RANGE",
  BARCODES: "BARCODES",
  INVOICES: "INVOICES",
  REF_NO: "REF_NO",
};

const GLOBAL_FILTER_ACTION_CREATORS = {
  setDateRange: (fromDate, toDate) => ({
    type: ACTIONS.DATE_RANGE,
    payload: { fromDate, toDate },
  }),
  setBarcodes: (barcodes) => ({
    type: ACTIONS.BARCODES,
    payload: { barcodes },
  }),
  setInvoices: (invoices) => ({
    type: ACTIONS.INVOICES,
    payload: { invoices },
  }),
  setReferenceNos: (referenceNos) => ({
    type: ACTIONS.REF_NO,
    payload: { referenceNos },
  }),
};

/**
 * @typedef {Object} GlobalFilterState
 * @property {"DateRange" | "Barcode" | "Invoice" | "RefNo"} searchBy
 * @property {string} fromDate
 * @property {string} toDate
 * @property {Array<string>} barcodes
 * @property {Array<string>} invoices
 * @property {Array<string>} referenceNos
 */

const reducerGlobalFilter = (state, action) => {
  switch (action.type) {
    case "DATE_RANGE":
      return {
        searchBy: orderSearchCategories.dateRange.value,
        fromDate: action.payload.fromDate,
        toDate: action.payload.toDate,
        invoices: [],
        barcodes: [],
        referenceNos: [],
      };
    case "BARCODES":
      return {
        ...state,
        searchBy: orderSearchCategories.barcode.value,
        invoices: [],
        barcodes: action.payload.barcodes,
        referenceNos: [],
      };
    case "INVOICES":
      return {
        ...state,
        searchBy: orderSearchCategories.invoice.value,
        barcodes: [],
        invoices: action.payload.invoices,
        referenceNos: [],
      };
    case "REF_NO":
      return {
        ...state,
        searchBy: orderSearchCategories.refNo.value,
        barcodes: [],
        invoices: [],
        referenceNos: action.payload.referenceNos,
      };
    default:
      return state;
  }
};

/**
 * @returns {[GlobalFilterState, Function]}
 */
const useGlobalFilter = () => {
  const actions = useReducer(reducerGlobalFilter, intialGlobalFilterState);

  return actions;
};

export { useGlobalFilter, GLOBAL_FILTER_ACTION_CREATORS };
